import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../lib/shared/validators";
import { customFieldValues } from "../custom_fields";
export const clientTypes = v.union(
  v.literal("individual"),
  v.literal("company"),
  v.literal("organization"),
);

export const clientStatus = v.union(v.literal("active"), v.literal("inactive"));
export const validatorClient = v.object({
  name: v.optional(v.string()),
  email: v.optional(v.string()),
  phone: v.optional(v.string()),
  address: v.optional(v.string()),
  city: v.optional(v.string()),
  country: v.optional(v.string()),
  taxId: v.optional(v.string()),
  contactPerson: v.string(),
  notes: v.optional(v.string()),

  code: v.optional(v.string()),
  type: v.optional(clientTypes),

  isExonerated: v.optional(v.boolean()),

  creditEnabled: v.optional(v.boolean()),
  creditLimit: v.optional(v.number()),
  creditTermDays: v.optional(v.number()),
  creditBalance: v.optional(v.number()),

  /** Valores de campos personalizados (Colecciones), por key de definición. */
  customFields: v.optional(customFieldValues),

  internalControl: internalControl,
});

export const clients = defineTable(validatorClient)
  .index("by_company_and_type", ["internalControl.companyId", "type"])
  .index("by_type", ["type"])
  .index("by_code", ["code"])
  .index("by_company_and_code", ["internalControl.companyId", "code"])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_and_state", [
    "internalControl.branchId",
    "internalControl.state",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_updated_by", ["internalControl.updatedBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ])
  .searchIndex("search_clients", {
    searchField: "name",
    filterFields: [
      "internalControl.companyId",
      "internalControl.branchId",
      "internalControl.state",
      "type",
    ],
  })
  .searchIndex("search_clients_contact_person", {
    searchField: "contactPerson",
    filterFields: [
      "internalControl.companyId",
      "internalControl.branchId",
      "internalControl.state",
      "type",
    ],
  });
